import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    addProductToList,
    removeProductFromList,
} from 'Store/ProductRelatedAccessories/ProductRelatedAccessories.action';

import ProductRelatedAccessoriesCard from './ProductRelatedAccessoriesCard.component';

/** @namespace Pwa/Component/ProductRelatedAccessoriesCard/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    addProducateRelated: (product) => dispatch(addProductToList(product)),
    removeProductRelated: (product) => dispatch(removeProductFromList(product)),
});

/** @namespace Pwa/Component/ProductRelatedAccessoriesCard/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Pwa/Component/ProductRelatedAccessoriesCard/Container */
export class ProductRelatedAccessoriesCardContainer extends PureComponent {
    static propTypes = {
        product: PropTypes.object.isRequired,
        addProducateRelated: PropTypes.func.isRequired,
        removeProductRelated: PropTypes.func.isRequired,
    };

    containerFunctions = {
        addAccessoriesToList: this.addAccessoriesToList.bind(this),
    };

    addAccessoriesToList(e) {
        const { addProducateRelated, removeProductRelated } = this.props;

        if (e.target.checked) {
            addProducateRelated(this.getDataRelated());
        }
        if (!e.target.checked) {
            removeProductRelated(this.getDataRelated());
        }
    }

    getDataRelated() {
        const {
            product: { sku, items, bundle_options, type_id },
        } = this.props;

        const productData = {
            sku,
            quantity: 1,
            items,
            bundle_options,
            type_id,
        };

        return productData;
    }

    containerProps() {
        const { product } = this.props;
        return {
            product,
        };
    }

    render() {
        return <ProductRelatedAccessoriesCard {...this.containerFunctions} {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductRelatedAccessoriesCardContainer);
